/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/NavGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Nav Groups
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:05 PM (CST)
 *  
 *  Notes:
 *      09/15/2018  NJN     Working on clean up to split out or eliminate code.
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    NAVGROUP_LIST_CONTAINER_LOADED,
    NAVGROUP_LIST_CONTAINER_UNLOADED,
    NAVGROUP_LIST_TABLE_LOADED,
    NAVGROUP_LIST_TABLE_UNLOADED,
    NAVGROUP_SELECT_ROW,
    NAVGROUP_ADD,
    NAVGROUP_EDIT,
    NAVGROUP_DELETE,
    NAVGROUP_DELETE_DISABLE,
    NAVGROUP_OPEN_WARNING,
    NAVGROUP_CLOSE_WARNING,
    NAVGROUP_VIEW_NAVS,

    NAVGROUP_EDIT_CONTAINER_LOADED,
    NAVGROUP_EDIT_CONTAINER_UNLOADED,
    NAVGROUP_EDIT_FORM_LOADED,
    NAVGROUP_EDIT_FORM_UNLOADED,
    NAVGROUP_EDIT_DATA_LOAD,
    NAVGROUP_EDIT_CONTAINER_SUBMIT,
    NAVGROUP_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeNavGroups';

const defaultState = {
    refreshList: false,
    navgroups: [],
    danger: false,
    navgroupid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case NAVGROUP_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                navgroups: action.payload ? action.payload.navgroups : []
            }
        case NAVGROUP_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case NAVGROUP_SELECT_ROW:
            return {
                ...state,
                navgroupid: action.id
            }
        case NAVGROUP_ADD:
            return {
                ...state
            }
        case NAVGROUP_EDIT:
            return {
                ...state,
                navgroupid: action.id
            }
        case NAVGROUP_DELETE:
            return {
                ...state,
                navgroupid: null
            }
        case NAVGROUP_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case NAVGROUP_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case NAVGROUP_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case NAVGROUP_VIEW_NAVS:
            return {
                ...state
            }
        case NAVGROUP_EDIT_CONTAINER_LOADED:
        case NAVGROUP_EDIT_DATA_LOAD:
            return {
                ...state,
                navgroupid: action.payload ? action.payload.navgroupid : 0,
                name: action.payload ? action.payload.name : '',
                description: action.payload ? action.payload.description : '',
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : ''
            }
        case NAVGROUP_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case NAVGROUP_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case NAVGROUP_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case NAVGROUP_LIST_CONTAINER_UNLOADED:
        case NAVGROUP_LIST_TABLE_UNLOADED:
        case NAVGROUP_EDIT_CONTAINER_UNLOADED:
        case NAVGROUP_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/NavGroups.js